var QGIV = QGIV || {};

/**
 * Matching Gifts Plugin
 * ********************************
 * functions:
 * init()
 * bindEvents()
 * unbindEvents()
 * toggleMatchingGifts()
 * setProvider()
 * filteredAmount()
 * updateAmount()
 * showConfirmEmail()
 * showSelection()
 * handleResultClick()
 * handleSearchInput()
 * triggerAPISearch()
 * renderNoResults()
 * appendResult()
 * renderResults()
 * clearFields()
 * clearSearchInputs()
 * clearResults()
 * resetSelection()
 * addPostData()
 **/
QGIV.MatchingGifts = {

    // flag to track whether initialized
    initialized : false,

    // processing flag to block multiple network calls
    processed : false,

    // limit searches to 1 per second
    searchTimeout : null,

    // check if a selection is already made when employer is updated
    selectionMade : false,

    // stores the selection data
    selectionData : {},

    // stores the form type
    formType : '',

    // stores whether view is in VT
    isVT : false,

    // stores the service as an int
    service : 0,

    // stores the email reference value from search
    emailRef : '',

    // stores the employer reference value from search
    employerRef : '',

    // stores the one time donation amount for comparison with
    // with matching gift amount
    oneTimeDonationAmount: "0",

    // selectors
    $doc : $( document ),
    _p2pRegistration : '.js-registration-step-information',
    _vtDonation : '#transaction-type-donation',
    _vtRegistration : '#transaction-type-registration',
    _vtP2PDonation : '#transaction-type-hobnob2-donation',
    _vtP2PRegistration : '#transaction-type-hobnob2-registration',
    _vtAuctionDonation : '#transaction-type-auction-donation',
    _vtAuctionRegistration : '#transaction-type-auction-registration',
    _companyField : '#company-name',
    $matchingGifts : $( '.js-matching-gifts' ),
    _vtMatchingGifts : '.js-vt-matching',
    _matchingService : '.js-matching-gift-service',
    _vtFormDropdown : '.js-selected-form',

    _resultsContainer : '.js-employer-list-container',
    _list : '.js-employer-list',
    _noResults : '.js-employer-no-results',
    _resultItem : '.js-employer-item',
    _cyberGrantsMessage : '.js-cybergrants-message',
    _cyberGrantsResult: '.js-cybergrants-result',
    _selection : '.js-employer-selection',
    _selectionAmount : '.js-employer-selection-amount',
    _selectionMessageWithAmount : '.js-employer-selection-withamount',
    _selectionMessageWithNoAmount : '.js-employer-selection-noamount',
    _selectionCompany : '.js-employer-selection-company',
    $totalLabel : $( '.js-transaction-total-label' ),
    _totalLabel : '.js-transaction-total-label',
    $vtTotalLabel : $( '.vt-total' ),
    _searchResult : '.js-search-result',

    _employerContainer : '.js-field-employer-container',
    _employerField : '#matching-employer',
    _personalInfoEmployerField : '#employer-field',
    _workEmailContainer : '.js-field-workemail-container',
    _workEmailField : '#workemail',
    _oneTimeDonation : '.one-time-donation',
    _oneTimeDonationAlt : '.js-one-time-donation',
    _vtOneTimeDonation : '#eventsOneTime',

    _poweredBy : '.js-employer-poweredby',
    _poweredByLogo : '.js-employer-poweredby-logo',

    _hiddenInputCompanyName : '#matching-company-name',
    _hiddenInputCompanyId : '#matching-company-id',
    _hiddenInputParentRawId : '#matching-parent-raw-id',
    _hiddenInputContactAddress1 : '#matching-contact-address1',
    _hiddenInputContactAddress2 : '#matching-contact-address2',
    _hiddenInputContactCity : '#matching-contact-city',
    _hiddenInputContactState : '#matching-contact-state',
    _hiddenInputContactZip : '#matching-contact-zip',
    _hiddenInputContactPhone : '#matching-contact-phone',
    _hiddenInputContactEmail : '#matching-contact-email',
    _hiddenInputDonorFound : '#matching-donor-found',
    _hiddenInputDonorVerified : '#matching-donor-verified',


    /**
     * @public
     * @method init
     * @description Inits event listeners
     */
    init : function() {
        var _this = this;
        
        // resets stored amount for comparison of matching gift amount
        // and the one time gift amount in p2p registration VT
        _this.oneTimeDonationAmount = "0";

        // set the form type
        if ( QGIV && QGIV.Form ) {
            if ( QGIV.Form.formType && QGIV.Form.formType === '1' ) {
                _this.formType = 'qgiv';
            } else if ( QGIV.Form.type && QGIV.Form.type === 'p2p' ) {
                _this.formType = 'p2p';
            } else if ( QGIV.Form.type && QGIV.Form.type === 'auction' ) {
                _this.formType = 'auction';
            }
            _this.isVT = false;
        } else if ( VTControl ) {
            _this.formType = VTControl.formType;
            _this.isVT = true;
        }

        // run the toggle on load to set values like "_this.$doc" or "_this.service"
        _this.toggleMatchingGifts();
    },

    /**
     * @public
     * @method bindEvents
     * @description binds events to the form
     */
    bindEvents : function() {
        var _this = this;
        var isHEP = _this.service === QGIV.MatchingGiftsServiceType( 'HEP_DATA' );
        var isDTD = _this.service === QGIV.MatchingGiftsServiceType( 'DOUBLE_THE_DONATION' );
        var isCyberGrants = _this.service === QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ) || _this.service === 0;

        // if Employer field is present, use its value to update the MG Employer field
        if ( $( _this._personalInfoEmployerField ).length ) {
            _this.$doc.on( 'keyup blur change', _this._personalInfoEmployerField, function() {
                _this.$doc.find( _this._employerField ).val( $( this ).val() ).trigger( 'change' );
            } );
        }

        // Work Email field event listener
        _this.$doc.on( 'keyup change blur', _this._workEmailField, function() {
            _this.handleSearchInput( 'email', $( this ).val() );
        } );
        
        // Employer field event listener
        _this.$doc.on( 'keyup blur change', _this._employerField, function() {
            _this.$doc.find( _this._personalInfoEmployerField ).val( $( this ).val() );
            if ( ! isCyberGrants ) _this.handleSearchInput( 'employer', $( this ).val() );
        } );

        // when an employer search result is clicked, add to form
        _this.$doc.on( 'click', _this._resultItem, function() {
            _this.handleResultClick( $( this ).index() + 1 );
        } );

        // only show Matching Gifts in the Donate tab
        _this.$doc.on( 'click', '.js-giving-option', function() {
            _this.toggleMatchingGifts();
        } );

        // hide Matching Gifts if Company field input has a value
        _this.$doc.on( 'keyup blur change', '#company-name', function() {
            _this.toggleMatchingGifts();
        } );

        // hide Matching Gifts if Company Donation is checked
        _this.$doc.on( 'change', '[name="Personal[companyDonation]"], [name="contact[companyDonation]"], #is-company-donation, #is-company-registration, #show_p2p_company_field, #show-auction-company-field', function() {
            _this.toggleMatchingGifts();
        } );

        // donation amount
        _this.$doc.on( 'click', '.js-donation-amount-option', function() {
            _this.updateAmount();
        } );

        // other donation amount
        _this.$doc.on( 'change', '.js-other-donation-amount', function() {
            _this.updateAmount();
        } );

        // Event one-time donation amount
        _this.$doc.on( 'change blur', [ _this._oneTimeDonation, _this._oneTimeDonationAlt ].join( ', ' ), function() {
            const newAmount = $(this).val();
            _this.oneTimeDonationAmount = newAmount;
            _this.toggleMatchingGifts();
        } );
        
        // Auction registration one-time donation amount
        // trigger change event on page load to hide initially
        _this.$doc.on( 'blur', '.js-onetime-donation', function() {
            _this.toggleMatchingGifts();
        } ).trigger( 'blur' );

        // multi restriction amount
        _this.$doc.on( 'change', '.js-multi-restriction-amount, .js-select-amount', function() {
            _this.updateAmount();
        } );

        // toggle MG section when a payment method is selected (examples: cc/cash/invoice/stored-account-cc)
        $( document ).on( 'change click', '.payment-option, .js-payment-type-option, .js-account-payment-method', function() {
            _this.toggleMatchingGifts();
        } );

        // toggle MG if one-time donation is set in the Additional Registrant's Information Step
        _this.$doc.on( 'change', '.registration-step', function() {
            if ( $( this ).is( _this._p2pRegistration ) ) {
                _this.toggleMatchingGifts();
            }
        } );

        _this.$doc.on("change", "input[name='match_gift']", function() {
            // if matching is enabled, copy selected amount for comparison. Scoped to VT p2p registration only
            if ( $('.js-matching-details').length && $("#transaction-type-hobnob2-registration").not(".hide-content").length)  {
                const maxAmountVal = _this.oneTimeDonationAmount
                const maxAmountFormatted = maxAmountVal?.replace(/,/g, '');
                const matchingRatio = $('.js-matching-gift-amount').attr('data-matching-ratio') || 1;

                $('.js-matching-gift-amount').attr('data-max-amount', maxAmountFormatted * matchingRatio);
            }
        })
    },


    /**
     * @public
     * @method unbindEvents
     * @description Removes event listeners, clears out data/values
     */
    unbindEvents : function() {
        var _this = this;

        _this.clearResults();
        _this.resetSelection();
        _this.clearFields();
        _this.clearSearchInputs();

        _this.$doc.off( 'keyup blur change', _this._personalInfoEmployerField );
        _this.$doc.off( 'keyup blur change', _this._workEmailField );
        _this.$doc.off( 'keyup blur change', _this._employerField );
        _this.$doc.off( 'click', _this._resultItem );
        _this.$doc.off( 'click', '.js-giving-option' );
        _this.$doc.off( 'keyup blur change', '#company-name' );
        _this.$doc.off( 'change', '#is-company-donation, #is-company-registration, #show_p2p_company_field, #show-auction-company-field' );
        _this.$doc.off( 'click', '.js-donation-amount-option' );
        _this.$doc.off( 'change', '.donation-amount-other-input' );
        _this.$doc.off( 'change', [ _this._oneTimeDonation, _this._oneTimeDonationAlt ].join( ', ' ) );
        _this.$doc.off( 'change', '.js-multi-restriction-amount' );
        $( document ).off( 'change click', '.payment-option, .js-payment-type-option, .js-account-payment-method' );

        _this.initialized = false;
    },


    /**
     * @public
     * @method toggleMatchingGifts
     * @description decides whether to display the Matching Gifts section
     */
    toggleMatchingGifts : function() {
        var _this = this;
        var hideMatchingGifts = false;
        var filteredOneTimeDonationAmount;
        var donationTabHidden = $( '#donation-type-amount' ).closest( '.toggle-content' ).is( '.hide-content' );
        var pledgeTabHidden = $( '#donation-type-pledge' ).closest( '.toggle-content' ).is( '.hide-content' );
        var hasOneTimeDonationField = _this.$doc.find( _this._oneTimeDonation ).length > 0;
        var isAuctionRegistration = _this.formType === 'auction' && $( '.is-auction-registration' ).length;

        /** hide the Matching Gift section if one of the following occurs:
            * user is in Events tab without a one-time donation
            * company field is required
            * company field has value
            * its a company donation
        */

        if ( QGIV.Form ) {
            
            // set the service provider
            _this.service = parseInt( _this.$doc.find( _this._matchingService ).val() );
            var isHEP = _this.service === QGIV.MatchingGiftsServiceType( 'HEP_DATA' );
            var isDTD = _this.service === QGIV.MatchingGiftsServiceType( 'DOUBLE_THE_DONATION' );
            var isCyberGrants = _this.service === QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ) || _this.service === 0;
            var urlContainsEvent = (document.location.href.indexOf( '?event=' ) !== -1 || 
                                    document.location.href.indexOf( '/event/' ) !== -1);

            if ( _this.formType === 'qgiv' ) {
                if ( (donationTabHidden && pledgeTabHidden) || urlContainsEvent ) {
    
                    // inside Events tab, check for One Time Donation field, and if value is 0, keep MG hidden
                    if ( hasOneTimeDonationField ) {
                        
                        // extracting out the number of the one-time amount in order to decide whether to hide MG (to compare against 0)
                        filteredOneTimeDonationAmount = _this.filteredAmount( $( '#event-' + $( '#event' ).val() + '-options' ).find( _this._oneTimeDonation ), 'number' );
                        if ( filteredOneTimeDonationAmount === 0 ) {
                            hideMatchingGifts = true;
                        }
                    } else {
                        hideMatchingGifts = true;
                    }
                }
            }

            if ( isAuctionRegistration ) {                

                // extracting out the number of the one-time amount in order to decide whether to hide MG (to compare against 0)
                filteredOneTimeDonationAmount = _this.filteredAmount( $( '.js-onetime-donation' ), 'number' );
                if ( filteredOneTimeDonationAmount > 0 ) {
                    hideMatchingGifts = false;
                } else {
                    hideMatchingGifts = true;
                }
            }

            // determine whether to show or hide MG
            if ( !$( '.donation-type-company' ).is( '.hide-content' ) && _this.$doc.find( _this._companyField ).closest( '.field-container' ).find( '.field-required-label' ).length > 0 ) {
                hideMatchingGifts = true;
            } else if ( _this.$doc.find( '#is-company-donation' ).is( ':checked' ) || _this.$doc.find( '#is-company-registration' ).is( ':checked' ) || _this.$doc.find( '#show_p2p_company_field' ).is( ':checked' ) || _this.$doc.find( '#show-auction-company-field' ).is( ':checked' ) ) {
                hideMatchingGifts = true;
            } else if ( $( '#payment-type-invoice' ).is( ':checked' ) ) {
                hideMatchingGifts = true;
            }

            if ( hideMatchingGifts ) {
                _this.resetSelection();
                _this.clearFields();
                _this.clearSearchInputs();
                _this.$matchingGifts.addClass( 'hide-content' );
            }  else {
                _this.$matchingGifts.removeClass( 'hide-content' );

                if ( isCyberGrants ) {
                    _this.$doc.find( _this._employerContainer ).addClass( 'hide-content' );
                    _this.$doc.find( _this._workEmailContainer ).removeClass( 'hide-content' );
                } else if ( ! _this.selectionMade ) {
                    _this.$doc.find( _this._employerContainer ).removeClass( 'hide-content' );
                    _this.$doc.find( _this._workEmailContainer ).addClass( 'hide-content' );
                }
            }
        } else {

            // update root selector to keep things in scope for the various instances of MG
            if ( _this.formType === 'vt_qgiv' || _this.formType === 'vt_p2p' ) {
                if ( $( '#option-vt-donation' ).is( ':checked' ) ) {
                    if ( _this.formType === 'vt_qgiv' ) {
                        _this.$doc = $( _this._vtDonation );
                    } else if ( _this.formType === 'vt_p2p' ) {
                        _this.$doc = $( _this._vtP2PDonation );
                    }
                } else if ( $( '#option-vt-registration' ).is( ':checked' ) ) {
                    if ( _this.formType === 'vt_qgiv' ) {
                        _this.$doc = $( _this._vtRegistration );
                    } else if ( _this.formType === 'vt_p2p' ) {
                        _this.$doc = $( _this._vtP2PRegistration );
                    }
                    filteredOneTimeDonationAmount = _this.filteredAmount( _this.$doc.find( _this._oneTimeDonationAlt ), 'number' );
                }
            } else if ( _this.formType === 'vt_auction' ) {
                if ( $( '.js-auction-tab.is-active' ).attr( 'data-view' ) === 'donate' ) {
                    _this.$doc = $( _this._vtAuctionDonation );
                } else if ( $( '.js-auction-tab.is-active' ).attr( 'data-view' ) === 'registration' ) {
                    _this.$doc = $( _this._vtAuctionRegistration );
                    filteredOneTimeDonationAmount = _this.filteredAmount( _this.$doc.find( _this._oneTimeDonationAlt ), 'number' );
                }
            }

            // set the service provider
            _this.service = parseInt( _this.$doc.find( _this._matchingService ).val() );
            var isHEP = _this.service === QGIV.MatchingGiftsServiceType( 'HEP_DATA' );
            var isDTD = _this.service === QGIV.MatchingGiftsServiceType( 'DOUBLE_THE_DONATION' );
            var isCyberGrants = _this.service === QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ) || _this.service === 0;
            var hasOneTimeDonationField = _this.$doc.find( _this._oneTimeDonationAlt ).length > 0;
            var isCompanyDonation = _this.$doc.find( '#is-company-donation' ).is( ':checked' );
            var isCompanyRegistration = _this.$doc.find( '#is-company-registration' ).is( ':checked' );
            var showP2PCompany = _this.$doc.find( '#show_p2p_company_field' ).is( ':checked' );
            var showAuctionCompany = _this.$doc.find( '#show-auction-company-field' ).is( ':checked' );

            // look for one-time donation field, and if present, initially hide MG until amount > $0
            if ( hasOneTimeDonationField ) {
                if ( filteredOneTimeDonationAmount === 0 ) {
                    _this.resetSelection();
                    _this.clearFields();
                    _this.clearSearchInputs();
                    hideMatchingGifts = true;
                }  else {
                    hideMatchingGifts = false;
                }
            }

            // hide MG if its a Company Donation/Registration
            if ( isCompanyDonation || isCompanyRegistration || showP2PCompany || showAuctionCompany ) {
                hideMatchingGifts = true;
            }

            // reset/clear/hide MG if clicking Cash or Check offline payment options
            if ( $( '.payment-option.active' ).attr( 'id' ) === 'cash-button' || $( '.payment-option.active' ).attr( 'id' ) === 'check-button' ) {

                // we dont support offline donations for HEP or DtD or CyberGrants
                if ( isHEP || isDTD || isCyberGrants ) {
                    _this.resetSelection();
                    _this.clearFields();
                    _this.clearResults();
                    _this.clearSearchInputs();
                    hideMatchingGifts = true;

                    // if the checkbox list container was open, close it
                    if ( $( '#show_matching_gifts' ).is( ':checked'  ) ) $( '#show_matching_gifts' ).trigger( 'click' );
                }
            }

            if ( isCyberGrants ) {
                _this.$doc.find( _this._workEmailContainer ).removeClass( 'hide-content' );
                _this.$doc.find( _this._employerContainer ).addClass( 'hide-content' );
            } else {
                _this.$doc.find( _this._workEmailContainer ).addClass( 'hide-content' );
                _this.$doc.find( _this._employerContainer ).removeClass( 'hide-content' );
            }

            // toggle the MG section
            if ( hideMatchingGifts ) {
                _this.$doc.find( _this._vtMatchingGifts ).addClass( 'hide-content' );

                // if the checkbox list container was open, close it
                if ( $( '#show_matching_gifts' ).is( ':checked'  ) ) $( '#show_matching_gifts' ).trigger( 'click' );
            } else {
                _this.$doc.find( _this._vtMatchingGifts ).removeClass( 'hide-content' );
            }
        }

        // add event listeners
        if ( ! _this.initialized ) {
            _this.bindEvents();
            _this.initialized = true;
        }
    },


    /**
     * @public
     * @method setProvider
     * @description Updates the "powered by ___" message depending on which provider was used
     */
    setProvider : function() {
        var _this = this;
        var $logo = _this.$doc.find( _this._poweredByLogo );

        // in p2p registration, donation and matching fields aren't loaded into in the DOM until Information step is started
        if ( _this.formType === 'p2p' && _this.$doc.find( _this._oneTimeDonationAlt ).length > 0 ) {
            _this.$doc = $( _this._p2pRegistration );
        }

        switch ( _this.service ) {
        case QGIV.MatchingGiftsServiceType( 'DOUBLE_THE_DONATION' ):
            $logo.prop( 'src', '/resources/core/images/logo-doubledonation.png' );
            $logo.prop( 'alt', 'Double the Donation' );
            break;
        case QGIV.MatchingGiftsServiceType( 'HEP_DATA' ):
            $logo.prop( 'src', '/resources/core/images/logo-hepdata.png' );
            $logo.prop( 'alt', 'HEPData' );            
            break;
        case QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ):
            $logo.prop( 'src', '/resources/core/images/logo-cybergrants.png' );
            $logo.prop( 'alt', 'CyberGrants' );
            break;
        case QGIV.MatchingGiftsServiceType( 'QGIV' ):
            $logo.prop( 'src', '/resources/core/images/logo-qgiv.png' );
            $logo.prop( 'alt', 'Qgiv' );
            break;
        }

        _this.$doc.find( _this._poweredBy ).removeClass( 'hide-content' );
    },

    /**
     * @public
     * @method filteredAmount
     * @description Returns the provided element's value, parsed as a number
     * @param {object} $el element being selected for value conversion
     * @param {string} dataType decides how to return the value, either "string" or "number"
     */
    filteredAmount : function( $el, dataType ) {
        var elementValue = $el.val();

        if ( dataType === 'string' ) {
            return ( elementValue ? elementValue.replace( /[^0-9\.]+/g, '' ) : '0.00' );
        } else {
            return Number( ( elementValue ? elementValue.replace( /[^0-9\.]+/g, '' ) : '0.00' ) );
        }
    },


    /**
     * @public
     * @method updateAmount
     * @description Updates amount shown in the selection box
     */
    updateAmount : function( ) {
        var _this = this;
        var total = '';
        var selectedOption = {};

        if ( QGIV.Form ) {
            if ( _this.formType === 'qgiv' ) {

                // see if Events tab is open, else, get total from bottom of Pledge/Donate tab
                if ( !$( '#donation-type-event' ).closest( '.toggle-content' ).is( '.hide-content' ) ) {
    
                    // check if Event's one-time donation has an amount
                    if ( $( '#event' ).length > 0 && _this.$doc.find( _this._oneTimeDonation ).length > 0 ) {
                        total = '$' + _this.filteredAmount( _this.$doc.find( _this._oneTimeDonation ), 'string' );
                    }
                } else {
                    if ( _this.$totalLabel.html().length === 0 ) {
                        total = '$0.00';
                    } else {
                        total = _this.$totalLabel.html();
                    }
                }
            } else if ( _this.formType === 'p2p' || _this.formType === 'auction' ) {
                if ( $( _this._oneTimeDonationAlt ).length > 0 ) {
                    total = '$' + _this.filteredAmount( _this.$doc.find( _this._oneTimeDonationAlt ), 'string' );
                } else {
                    total = '$' + $( '#registration-total span' ).text();
                }
            }
        } else {
            
            // in VT, check for One-Time Donation in Registration tab, else, get value from the Total label
            if ( $( '.eventContainer' ).is( '.allowDonation' ) ) {

                // VT Qgiv Events
                total = '$' + _this.filteredAmount( _this.$doc.find( _this._oneTimeDonationAlt ), 'string' );
            } else if ( $( '.js-auction-donate-view.fade-in-content' ).length > 0 ) {

                // VT Auction Donation
                selectedOption = _this.$doc.find( '.js-select-amount option:selected' );
                if ( selectedOption.val() === 'other' ) {
                    total = '$' + _this.filteredAmount( _this.$doc.find( '.js-other-donation-amount' ), 'string' );
                } else {
                    total = '$' + _this.filteredAmount( _this.$doc.find( '.js-select-amount option:selected' ), 'string' );
                }
            } else if ( $( '.js-auction-registration-view.fade-in-content' ).length > 0 ) {

                // VT Auction Registration
                total = '$' + _this.filteredAmount( _this.$doc.find( _this._oneTimeDonationAlt ), 'string' );
            } else if ( _this.formType === 'vt_p2p' && _this.$doc.find( _this._oneTimeDonationAlt ).length > 0 ) {

                // VT P2P Registration
                total = '$' + _this.filteredAmount( _this.$doc.find( _this._oneTimeDonationAlt ), 'string' );
            } else {
                if ( _this.$vtTotalLabel.html().length === 0 ) {
                    total = '$0.00';
                } else {
                    total = _this.$vtTotalLabel.html();
                }
            }
        }

        // check if amount is zero, and determine which selection message to display
        if ( Number( total.replace( /[^0-9\.]+/g, '' ) ) === 0 ) {
            _this.$doc.find( _this._selectionMessageWithAmount ).addClass( 'hide-content' );
            _this.$doc.find( _this._selectionMessageWithNoAmount ).removeClass( 'hide-content' );
        } else {
            _this.$doc.find( _this._selectionMessageWithAmount ).removeClass( 'hide-content' );
            _this.$doc.find( _this._selectionMessageWithNoAmount ).addClass( 'hide-content' );
        }

        _this.$doc.find( _this._selectionAmount ).text( total );
    },


    /**
     * @public
     * @method showConfirmEmail
     * @description shows the "Please confirm with your corp email" and Work Email field
     */
    showConfirmEmail : function() {
        var _this = this;

        if ( _this.$doc.find( _this._selectionCompany ).val().length > 0 ) {
            _this.$doc.find( _this._cyberGrantsMessage ).removeClass( 'hide-content' );
        }

        // ensure that work email field is blank when revealed to allow new search
        _this.$doc.find( _this._workEmailField ).val( '' );
        _this.$doc.find( _this._workEmailContainer ).removeClass( 'hide-content' );
    },

    /**
     * @public
     * @method showSelection
     * @description shows the checkmark with the selection info
     * @param {string} selectionType decides which type of selection to show, either "email" or "company"
     */
    showSelection : function(selectionType) {
        var _this = this;
        var isHEP = _this.service === QGIV.MatchingGiftsServiceType( 'HEP_DATA' );
        var isDTD = _this.service === QGIV.MatchingGiftsServiceType( 'DOUBLE_THE_DONATION' );
        var isCyberGrants = _this.service === QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ) || _this.service === 0;
        var $root;

        // hide 'no results' message'
        _this.$doc.find( _this._noResults ).addClass( 'hide-content' );

        switch ( selectionType ) {
        case 'donorVerified':
            _this.$doc.find( _this._cyberGrantsResult ).removeClass( 'hide-content' );
            break;
        case 'company':
            _this.$doc.find( _this._selection ).removeClass( 'hide-content' );
            break;
        }

        // check if inside VT, then if using automated service, show message about not supporting offline payment methods
        if ( _this.isVT && ( isHEP || isDTD || isCyberGrants ) ) {
            if ( $( '.js-payment' ).length > 0 ) {
                $root = $( '.js-payment' );
            } else if ( $( '.show-modal .js-payment-container' ).length > 0 ) {
                $root = $( '.js-payment-container' );
            }

            $root.find( '.section-heading' ).after( 
                '<p class="js-vt-matching-payment-warning field-text">' +
                    '<strong>Note: </strong>' +
                    'Employer-matched donations cannot be processed by offline ' +
                    'payment methods such as Cash or Check</p>' );
        }

        // if HEP is used in VT, email is required, but only if there's a match happening 
        if ( _this.isVT && isHEP ) {
            _this.$doc.find( _this._workEmailContainer ).find( '.js-workemail-required' ).removeClass( 'hide-content' );
            _this.$doc.find( _this._workEmailContainer ).removeClass( 'hide-content' );
            _this.$doc.find( _this._workEmailField ).addClass( 'validateEmpty validateEmail' );
        }

        _this.setProvider();
    },

    /**
     * @public
     * @method handleResultClick
     * @description handles click event when a result is selected from the list of possible employers
     * @param {number} selectionIndex The index of the selection within the list of results
     */
    handleResultClick : function( selectionIndex ) {
        var _this = this;
        var $selection = _this.$doc.find( '.js-employer-item:nth-child(' + selectionIndex + ')' );
        var isDTD = _this.service === QGIV.MatchingGiftsServiceType( 'DOUBLE_THE_DONATION' );

        _this.selectionData = {
            company_name : $selection.find( '.js-employer-name' ).text(),
            company_id : $selection.attr( 'data-company-id' ),
            parent_raw_id : $selection.attr( 'data-parent-raw-id' ),
            company_subsidiary : $selection.find( '.js-employer-subsidiaryof' ).text(),
            contact_address1 : $selection.attr( 'data-contact-address1' ),
            contact_address2 : $selection.attr( 'data-contact-address2' ),
            contact_city : $selection.attr( 'data-contact-city' ),
            contact_state : $selection.attr( 'data-contact-state' ),
            contact_zip : $selection.attr( 'data-contact-zip' ),
            contact_phone : $selection.attr( 'data-contact-phone' ),
            contact_email : $selection.attr( 'data-contact-email' )
        };

        // prevent None option from being treated like a real result
        if ( _this.selectionData.company_name === 'None of these are my employer' ) {
            _this.clearResults();
            _this.showConfirmEmail();
            _this.selectionData.company_name = '';
        }

        // if data comes back empty, don't continue
        if ( ! _this.selectionData.company_name.length > 0 ) return;

        // add employer + subsidiary if present, else, add employer name
        if ( _this.selectionData.company_subsidiary ) {
            _this.employerRef = _this.selectionData.company_name + ' (Subsidiary of ' + _this.selectionData.company_subsidiary + ')';
        } else {
            _this.employerRef = _this.selectionData.company_name;
        }

        // apply the selected employer's company name
        _this.$doc.find( _this._selectionCompany ).text( _this.selectionData.company_name );
        _this.$doc.find( _this._employerField ).val( _this.employerRef );

        // check for whether there's an Employer field in Personal Information, and update that as well
        if ( _this.$doc.find( _this._personalInfoEmployerField ).length ) {
            _this.$doc.find( _this._personalInfoEmployerField ).val( _this.$doc.find( _this._employerField ).val() );
        }
        
        // apply the amount
        _this.updateAmount();

        // pass the selection to the hidden inputs
        _this.$doc.find( _this._hiddenInputCompanyName ).val( _this.selectionData.company_name );
        _this.$doc.find( _this._hiddenInputCompanyId ).val( _this.selectionData.company_id );
        _this.$doc.find( _this._hiddenInputParentRawId ).val( _this.selectionData.parent_raw_id );
        _this.$doc.find( _this._hiddenInputContactAddress1 ).val( _this.selectionData.contact_address1 );
        _this.$doc.find( _this._hiddenInputContactAddress2 ).val( _this.selectionData.contact_address2 );
        _this.$doc.find( _this._hiddenInputContactCity ).val( _this.selectionData.contact_city );
        _this.$doc.find( _this._hiddenInputContactState ).val( _this.selectionData.contact_state );
        _this.$doc.find( _this._hiddenInputContactZip ).val( _this.selectionData.contact_zip );
        _this.$doc.find( _this._hiddenInputContactPhone ).val( _this.selectionData.contact_phone );
        _this.$doc.find( _this._hiddenInputContactEmail ).val( _this.selectionData.contact_email );

        // an employer is chosen from the list of results. clear the list, show the results
        _this.$doc.find( _this._list ).html( '' );
        _this.$doc.find( _this._resultsContainer ).addClass( 'hide-content' );

        // update state to track whether to keep or clear the selection data
        _this.selectionMade = true;

        _this.showConfirmEmail();
    },

    /**
     * @public
     * @method handleSearchInput
     * @description handles search input keyup/change events for Employer and Work Email fields
     * @param {string} input : either 'email' or 'employer'
     * @param {string} value : the value of the input
     */
    handleSearchInput : function( input, value ) {
        var _this = this;
        if ( value.length < 1 && !(input === 'email' && _this.selectionMade) ) {
            if ( _this.selectionMade || _this.service === QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ) || _this.service === 0 ) {
                _this.clearResults();
                _this.clearFields();
                _this.resetSelection();
                _this.selectionMade = false; 
            } 
        } 

        // ensure we don't over-request and only change when value has changed
        if ( _this.processed ) return;

        if ( value === _this.employerRef || value === _this.emailRef ) return;
        if ( value.length <= 2 ) return;

        // update reference value and show the inline loading icon
        if ( input === 'employer' ) {

            // check state to decide whether this is a new or continued search
            if ( _this.selectionMade && _this.employerRef.length > 0 ) {
                _this.resetSelection();
                _this.clearFields();
                _this.clearResults();
                _this.clearSearchInputs();
                _this.selectionMade = false;
            }
            
            _this.$doc.find( _this._employerContainer + ' .inline-loading' ).addClass( 'is-loading' );
            _this.employerRef = value;
        } else if ( input === 'email' ) {
            _this.$doc.find( _this._workEmailContainer + ' .inline-loading' ).addClass( 'is-loading' );
            _this.emailRef = value;
        }

        // start the 1 second timer before actually searching
        if ( _this.searchTimeout ) window.clearTimeout( _this.searchTimeout );
        _this.searchTimeout = window.setTimeout( function() {
            _this.triggerAPISearch( input, value );
        }, 1000 );
    },


    /**
     * @public
     * @method triggerAPISearch
     * @description calls API & renders the response
     * @param {input} is a string, either 'email' or 'employer'
     * @param {value} is the value of the input
     */
    triggerAPISearch : function( input, value ) {
        var _this = this;
        var isHEP = _this.service === QGIV.MatchingGiftsServiceType( 'HEP_DATA' );
        var postData = {
            prefix : '',
            email : ''
        };
        if ( input === 'employer' ) {
            postData.prefix = value;
        } else if ( input === 'email' ) {
            postData.email = value;

            // use emailConfirmation flag to directly search CG
            // search CG to either confirm employer selection, or if searching email with HEP
            if ( (_this.selectionMade && _this.employerRef.length > 0) || isHEP ) {
                postData.emailConfirmation = '1';
            }
        }

        // check for, and update, processing flag
        if ( _this.processed ) return false;
        _this.processed = true;

        _this.clearResults();
        
        if ( QGIV.Form ) {

            // form key
            if ( QGIV.Form.formKey && QGIV.Form.formKey.length ) {
                postData.formKey = QGIV.Form.formKey;
            } else if ( QGIV.Form.type === 'p2p' ) {
                postData.formKey = QGIV.Form.alias;
            }

            // form type
            if ( _this.formType === 'qgiv' ) {
                postData.formType = QGIV.Form.formType;
            } else if ( _this.formType === 'p2p' ) {
                postData.formType = '3';
            } else if ( QGIV.Form.type && QGIV.Form.type === 'auction' ) {
                postData.formType = '5';
            }
        } else {

            // for vt qgiv
            postData.formKey = encodeURIComponent( $( '.js-selected-form option:selected' ).attr( 'data-key' ) );

            // TODO: update this for vt p2p
            postData.formType = '1';
        }

        if ( $( '#csrfToken' ).val() ) {
            postData.csrfToken = $( '#csrfToken' ).val();
        }

        return $.fn.qpost( {
            url : '/services/matching/validate.php',
            data : postData,
            success : function( data ) {
                _this.processed = false;

                if ( data.success ) {

                    // if an email is in results data, show email search results in selection
                    // else, show company search results
                    if (data.result && data.result[0]['email'] ) {
                        if ( data.result[0][ 'donorVerified' ] ) {
                            
                            // since CyberGrants found a result, use that instead of DtD/HEP data
                            _this.service = QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' );
                            _this.$doc.find( _this._hiddenInputDonorVerified ).val( '1' );
                            _this.$doc.find( _this._hiddenInputDonorFound ).val( '1' );
                            _this.showSelection( 'donorVerified' );
                        } else if ( data.result[0][ 'donorExists' ] ) {
                            _this.service = parseInt( _this.$doc.find( _this._matchingService ).val() );
                            _this.$doc.find( _this._hiddenInputDonorVerified ).val( '0' );
                            _this.$doc.find( _this._hiddenInputDonorFound ).val( '1' );
                        } else {
                            _this.service = parseInt( _this.$doc.find( _this._matchingService ).val() );
                            _this.$doc.find( _this._hiddenInputDonorVerified ).val( '0' );
                            _this.$doc.find( _this._hiddenInputDonorFound ).val( '0' );
                        }

                        // if donor isnt verified and no company data, render No Results message
                        // else, if theres company data, show the company selection
                        if (! data.result[0][ 'donorVerified' ] && ! _this.selectionData.company_name ) {
                            _this.renderNoResults();
                        } else if ( _this.service !== QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ) && _this.selectionData.company_name && _this.selectionData.company_name.length > 0 ) {
                            _this.showSelection( 'company' );
                        }
                    } else {
                        _this.renderResults( data.result );
                    }
                } else {
                    if ( _this.selectionData.company_name && _this.selectionData.company_name.length > 0 ) {
                        _this.showSelection( 'company' );
                    } else {
                        _this.renderNoResults();
                    }

                    _this.$doc.find( _this._workEmailContainer ).removeClass( 'hide-content' );
                }

                $( '.inline-loading' ).removeClass( 'is-loading' );
            },
            failure : function() {
                _this.processed = false;

                _this.renderNoResults();
                $( '.inline-loading' ).removeClass( 'is-loading' );
            }
        } );
    },


    /**
     * @public
     * @method renderNoResults
     * @description Toggles the "no results" message
     */
    renderNoResults : function() {
        var _this = this;

        _this.$doc.find( _this._noResults ).removeClass( 'hide-content' );
    },


    /**
     * @public
     * @method appendResult
     * @description Small function used to render a result, used in a loop
     * @param {object} result `data.result[i]` array item that comes back from the POST call to /services/matching/validate
     */
    appendResult : function( result ) {
        var _this = this;

        if ( result.subsidiaryOf && result.subsidiaryOf.length > 0 ) {
            _this.$doc.find( _this._list ).append(
                '<li class="employer-item js-employer-item" ' + 
                    'data-contact-address1="' + result.contact_address_line1 + '" data-contact-address2="' + result.contact_address_line2 + '" ' + 
                    'data-contact-city="' + result.contact_city + '" data-contact-state="' + result.contact_state + '" ' + 
                    'data-contact-zip="' + result.contact_zip + '" data-contact-phone="' + result.contact_phone + '" data-contact-email="' + result.contact_email + '" ' + 

                    'data-ratio="' + result.ratio + '" data-company-id="' + result.id + '" data-parent-raw-id="' + result.parent_raw_id + '" data-match-offered="' + result.matching_gift_offered + '" ' +
                    'data-min-amount="' + result.minimum_matched_amount + '" data-max-amount="' + result.maximum_matched_amount + '">' +

                    '<div class="employer-item-selection"><span class="ui-icon margin-left-half" data-icon="&#xe603;"></span>' + 
                        '<span class="employer-name js-employer-name margin-right-half">' + 
                            result.company_name + 
                        '</span>' + '|' + 
                    '<span class="employer-subsidiaryof js-employer-subsidiaryof margin-left-half">' + 
                        result.subsidiaryOf + 
                    '</span></div></li>' );
        } else {
            _this.$doc.find( _this._list ).append(
                '<li class="employer-item js-employer-item" ' + 
                    'data-contact-address1="' + result.contact_address_line1 + '" data-contact-address2="' + result.contact_address_line2 + '" ' + 
                    'data-contact-city="' + result.contact_city + '" data-contact-state="' + result.contact_state + '" ' + 
                    'data-contact-zip="' + result.contact_zip + '" data-contact-phone="' + result.contact_phone + '" data-contact-email="' + result.contact_email + '" ' +

                    'data-ratio="' + result.ratio + '" data-company-id="' + result.id + '" data-parent-raw-id="' + result.parent_raw_id + '" data-match-offered="' + result.matching_gift_offered + '" ' +
                    'data-min-amount="' + result.minimum_matched_amount + '" data-max-amount="' + result.maximum_matched_amount + '">' +
                    '<div class="employer-item-selection"><span class="ui-icon margin-left-half" data-icon="&#xe603;"></span>' + 
                    '<span class="employer-name js-employer-name">' + 
                        result.company_name + 
                    '</span></div></li>' );
        }
    },


    /**
     * @public
     * @method renderResults
     * @description Renders the list of employers
     * @param {object} data `data.result` that comes back from the POST call to /services/matching/validate
     */
    renderResults : function( data ) {
        var _this = this;
        var i;

        // hide 'no results' message'
        _this.$doc.find( _this._noResults ).addClass( 'hide-content' );

        if ( data.length < 1 ) {
            _this.appendResult( data );
        } else {
            for ( i = 0; i < data.length; i++ ) {
                _this.appendResult( data[ i ] );

                // we're finished processing once we've gone through the last item in the list
                if ( i === ( data.length - 1 ) ) {

                    // add the "none" answer at the end of the list
                    _this.$doc.find( _this._list ).append( '<li class="employer-item js-employer-item js-employer-none employer-none">' +
                        '<div class="employer-item-selection">' + '<span class="ui-icon" data-icon="&#xe6f9;"></span>' + 
                        '<span class="employer-name js-employer-name margin-left-half">' +
                            '<i class="icon icon-none"></i>None of these are my employer' +
                        '</span></div></li>' );

                    _this.$doc.find( _this._resultsContainer ).removeClass( 'hide-content' );
                    _this.$doc.find( _this._list ).removeClass( 'hide-content' );
                }
            }

            // trigger a resize so that height can be recalculated with new content
            if ( _this.formType === 'qgiv' ) Embed.resize();
        }
    },


    /**
     * @public
     * @method clearResults
     * @description 
     */
    clearResults : function() {
        var _this = this;

        _this.$doc.find( _this._noResults ).addClass( 'hide-content' );
        _this.$doc.find( _this._resultsContainer ).addClass( 'hide-content' );
        _this.$doc.find( _this._selection ).addClass( 'hide-content' );
        _this.$doc.find( _this._poweredBy ).addClass( 'hide-content' );
        _this.$doc.find( _this._searchResult ).html( '' );
        _this.$doc.find( _this._list ).html( '' );
        _this.$doc.find( _this._cyberGrantsResult ).addClass( 'hide-content' );
       
        if ( _this.isVT ) {
            $( '.js-payment' ).find( '.js-vt-matching-payment-warning' ).remove();
        }
    },


    /**
     * @public
     * @method clearFields
     * @description 
     */
    clearFields : function() {
        var _this = this;
        var isCyberGrants = _this.service === QGIV.MatchingGiftsServiceType( 'CYBER_GRANTS' ) || _this.service === 0;

        // clear search input stored reference values
        _this.emailRef = '';
        _this.employerRef = '';

        // clear hidden input values
        _this.$doc.find( _this._hiddenInputCompanyName ).val( '' );
        _this.$doc.find( _this._hiddenInputCompanyId ).val( '' );
        _this.$doc.find( _this._hiddenInputParentRawId ).val( '' );
        _this.$doc.find( _this._hiddenInputContactAddress1 ).val( '' );
        _this.$doc.find( _this._hiddenInputContactAddress2 ).val( '' );
        _this.$doc.find( _this._hiddenInputContactCity ).val( '' );
        _this.$doc.find( _this._hiddenInputContactState ).val( '' );
        _this.$doc.find( _this._hiddenInputContactZip ).val( '' );
        _this.$doc.find( _this._hiddenInputContactPhone ).val( '' );
        _this.$doc.find( _this._hiddenInputContactEmail ).val( '' );
        _this.$doc.find( _this._hiddenInputDonorFound ).val( '' );
        _this.$doc.find( _this._hiddenInputDonorVerified ).val( '' );

        // re-hide the Work Email field
        if ( isCyberGrants ) {
            _this.$doc.find( _this._cyberGrantsResult ).addClass( 'hide-content' );
            _this.$doc.find( _this.donorVerified ).addClass( 'hide-content' );
            _this.$doc.find( _this._donorNotFound ).addClass( 'hide-content' );
            _this.$doc.find( _this.donorExists ).addClass( 'hide-content' );
        } else {
            _this.$doc.find( _this._workEmailContainer ).addClass( 'hide-content' );
        }
    },


    /**
     * @public
     * @method clearSearchInputs
     * @description 
     */
    clearSearchInputs : function() {
        var _this = this;

        // clear search input values
        _this.$doc.find( _this._workEmailField ).val( '' );
        _this.$doc.find( _this._employerField ).val( '' );

        // clear any validation
        _this.$doc.find( _this._workEmailContainer ).find( '.field-message' ).remove();
    },


    /**
     * @public
     * @method resetSelection
     * @description 
     */
    resetSelection : function() {
        var _this = this;
        _this.selectionData = {};
        _this.$doc.find( _this._selection ).addClass( 'hide-content' );
        _this.$doc.find( _this._noResults ).addClass( 'hide-content' );
        _this.$doc.find( _this._list ).addClass( 'hide-content' );
        _this.$doc.find( _this._cyberGrantsMessage ).addClass( 'hide-content' );
        _this.$doc.find( _this._cyberGrantsResult ).addClass( 'hide-content' );
    },


    /**
     * @public
     * @method addPostData
     * @description 
     */
    addPostData : function( formType ) {
        var _this = this;
        var post = '';

        switch ( formType ) {
        case 'vt_p2p_donation':
        case 'vt_p2p_registration':
            post += '&workEmail=' + encodeURIComponent( _this.$doc.find( '[name="workEmail"]' ).val_or_empty() );
            break;
        case 'vt_qgiv_donation':
        case 'vt_auction_donation':
            post += '&Personal[workEmail]=' + encodeURIComponent( _this.$doc.find( '[name="workEmail"]' ).val_or_empty() );
            break;
        case 'vt_qgiv_registration':
            post += '&Personal[workEmail]=' + encodeURIComponent( _this.$doc.find( '[name="workEmail"]' ).val_or_empty() );
        case 'vt_auction_registration':
            post += '&contact[workEmail]=' + encodeURIComponent( _this.$doc.find( '[name="workEmail"]' ).val_or_empty() );
            break;
        }

        // if Employer hasnt been filled out in Personal Info section, copy over the value from MG's Employer field
        if ( !_this.$doc.find( '[name="Personal[employer]"]' ).length ) {
            post += '&Personal[employer]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[company_name]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[company_name]"]' ).length > 0 && _this.$doc.find( '[name="Matching[company_name]"]' ).val().length > 0 ) {
            post += '&Matching[company_name]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[company_name]"]' ).val_or_empty() );
        } else if ( _this.$doc.find('[name="Matching[company_name]"]').length && _this.service === 2 ) {
            post += '&Matching[company_name]=';
        }
        if ( _this.$doc.find( '[name="Matching[company_id]"]' ).length > 0 && _this.$doc.find( '[name="Matching[company_id]"]' ).val().length > 0 ) {
            post += '&Matching[company_id]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[company_id]"]' ).val_or_empty() );
        } else if ( _this.$doc.find('[name="Matching[company_id]"]').length && _this.service === 2 ) {
            post += '&Matching[company_id]=';
        }
        if ( _this.$doc.find( '[name="Matching[parent_raw_id]"]' ).length > 0 && _this.$doc.find( '[name="Matching[parent_raw_id]"]' ).val().length > 0 ) {
            post += '&Matching[parent_raw_id]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[parent_raw_id]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[contact_address_line1]"]' ).length > 0 && _this.$doc.find( '[name="Matching[contact_address_line1]"]' ).val().length > 0 ) {
            post += '&Matching[contact_address_line1]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[contact_address_line1]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[contact_address_line2]"]' ).length > 0 && _this.$doc.find( '[name="Matching[contact_address_line2]"]' ).val().length > 0 ) {
            post += '&Matching[contact_address_line2]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[contact_address_line2]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[contact_city]"]' ).length > 0 && _this.$doc.find( '[name="Matching[contact_city]"]' ).val().length > 0 ) {
            post += '&Matching[contact_city]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[contact_city]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[contact_state]"]' ).length > 0 && _this.$doc.find( '[name="Matching[contact_state]"]' ).val().length > 0 ) {
            post += '&Matching[contact_state]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[contact_state]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[contact_zip]"]' ).length > 0 && _this.$doc.find( '[name="Matching[contact_zip]"]' ).val().length > 0 ) {
            post += '&Matching[contact_zip]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[contact_zip]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[contact_phone]"]' ).length > 0 && _this.$doc.find( '[name="Matching[contact_phone]"]' ).val().length > 0 ) {
            post += '&Matching[contact_phone]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[contact_phone]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[contact_email]"]' ).length > 0 && _this.$doc.find( '[name="Matching[contact_email]"]' ).val().length > 0 ) {
            post += '&Matching[contact_email]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[contact_email]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[donor_found]"]' ).length > 0 && _this.$doc.find( '[name="Matching[donor_found]"]' ).val().length > 0 ) {
            post += '&Matching[donor_found]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[donor_found]"]' ).val_or_empty() );
        }
        if ( _this.$doc.find( '[name="Matching[donor_verified]"]' ).length > 0 && _this.$doc.find( '[name="Matching[donor_verified]"]' ).val().length > 0 ) {
            post += '&Matching[donor_verified]=' + encodeURIComponent( _this.$doc.find( '[name="Matching[donor_verified]"]' ).val_or_empty() );
        }

        return post;
    }
};

/**
 * @public
 * @method MatchingGiftsServiceType
 * @memberof QGIV
 * @param {string} serviceType The service being used for matching gifts
 * @description Given a string, returns an enum representing the org's selected search providier
 */
QGIV.MatchingGiftsServiceType = function( serviceType ) {
    var ENUMS = {
        CYBER_GRANTS : 1,
        DOUBLE_THE_DONATION : 2,
        HEP_DATA : 3,
        QGIV : 4
    };

    return ENUMS[ serviceType ];
};
